// removed by extract-text-webpack-plugin
module.exports = {"fadein":"kae9Oz5dQqMe-Mpocbmmf"};


//////////////////
// WEBPACK FOOTER
// ./src/ConnectedComponents/utils/AnimatedLogo/index.css
// module id = 1445
// module chunks = 1